module.exports = __webpack_public_path__ + "img/chat-emoji.284319de.svg";